export default {
  salaryModel: {
    '': '不限',
    day: '日结',
    week: '周结',
    month: '月结',
  },
  salary: {
    0: '不限',
    1: '1K以下',
    2: '1K-2K',
    3: '2K-3K',
    4: '3K-5K',
    5: '5K-8K',
    6: '8K-12K',
    7: '12K-20K',
    8: '20K以上',
    9: '面议',
  },
  timeFrom: {
    0: '不限',
    1: '今天',
    2: '三天内',
    3: '一周内',
    4: '一个月内',
    5: '三个月内',
  },
  age: {
    0: '不限',
    1: '16-20岁',
    2: '21-30岁',
    3: '31-40岁',
    4: '41-50岁',
    5: '50岁以上',
  },
  refreshCron: {
    1: '每隔1小时刷新',
    2: '每隔2小时刷新',
    3: '每隔3小时刷新',
    4: '每隔4小时刷新',
    5: '每隔5小时刷新',
    6: '每隔6小时刷新',
    7: '每隔7小时刷新',
    8: '每隔8小时刷新',
    9: '每隔9小时刷新',
    10: '每隔10小时刷新',
    11: '每隔11小时刷新',
    12: '每隔12小时刷新',
    24: '每隔24小时刷新',
    48: '每隔48小时刷新',
  },
  testSite: [
    'job-test.myjiedian.com',
    'rc.tltwx.com', // 内蒙古通辽团
    'www.shangraozp.com', // 上饶直聘
    'www.tqukeji.com', // 天府职聘网
    'www.cqwulong.net', // 爱武隆人才网
    'www.jinrikz.cn', // 今日开州人才网
    'job.yc0795.cn', // 宜春直聘
    'www.zp0564.com', // 霍邱招聘网
    'job.ydweibao.com', // 英德人才网
    'www.lianshui666.com', // 涟水人才网
  ],
};
